import { SVGProps } from 'react';

export const BankIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23 22V24H0.99998V22H23ZM23.532 6L23.0621 7.84341L11.996 4L0.950605 7.88805L0.614868 6L12 2L23.532 6ZM6.99998 8V20H4.99998V8H6.99998ZM15 8V20H13V8H15ZM19 8V20H17V8H19ZM11 8V20H8.99998V8H11Z"
        fill="currentColor"
      />
    </svg>
  );
};
